module.exports = __webpack_public_path__ + "static/media/vtpLogo.36decdc3.png";